import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import { IBank } from '../../dashboard/home/user-bank/user-bank.component';
import {AuthService} from './auth.service';
import {FormControl, Validators} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private USER_ENDPOINT = '/user';
  userBank$ = new BehaviorSubject<IBank>({} as IBank);
  constructor(private apiService: ApiService, private authService: AuthService) {
    this.authService.isAuthenticated.pipe(take(1)).subscribe(
      (isAuthenticated) => {
        if (isAuthenticated) {
          this.getUserSettings().subscribe();
        }
      }
    );

  }

  get(): Observable<any> {
    return this.apiService.get(environment.endpoint + this.USER_ENDPOINT);
  }

  update(data): Observable<any> {
    return this.apiService.put('/users/admin/update/profile', data);
  }

  support(msg): Observable<any> {
    return this.apiService.post('/admin/email/support', msg )
      .pipe(map(data => data));
  }

  getProfile(): Observable<any> {
    return this.apiService.get(environment.endpoint + this.USER_ENDPOINT + '/profile');
  }

  getUserSettings(): Observable<any> {
    return this.apiService.get(environment.endpoint + this.USER_ENDPOINT + '/settings')
      .pipe(
        map( data => {
          this.setBank(data.bank);
          return data;
        })
      );
  }

  getBank(): Observable<IBank> {
    return this.userBank$.asObservable();
  }

  setBank(bank: IBank) {
    this.userBank$.next(bank);
  }

  getChildAccounts(): Observable<any> {
    return this.apiService.get(environment.endpoint + this.USER_ENDPOINT + '/child-accounts');
  }

  getChildAccountData(accountId: string): Observable<any> {
    return this.apiService.get(environment.endpoint + this.USER_ENDPOINT + `/child-account/${accountId}`);
  }

}
